import React, { useState } from 'react';
import { cn } from '@/lib/utils';

interface MiniMapProps {
  latitude: number;
  longitude: number;
  displayName: string;
  displayId: number;
  hasRealCoordinates: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

const MiniMap: React.FC<MiniMapProps> = ({ 
  latitude, 
  longitude, 
  displayName,
  displayId,
  hasRealCoordinates,
  size = 'sm',
  className
}) => {
  const [imageError, setImageError] = useState(false);
  
  // Don't render map for placeholder coordinates
  if (!hasRealCoordinates || imageError) {
    return null;
  }

  const mapSize = size === 'sm' ? { width: 150, height: 120 } : { width: 200, height: 160 };
  const zoom = size === 'sm' ? 14 : 15;
  
  // Construct Mapbox Static API URL
  const mapboxToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;
  const staticMapUrl = `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/pin-s+059669(${longitude},${latitude})/${longitude},${latitude},${zoom},0/${mapSize.width}x${mapSize.height}@2x?access_token=${mapboxToken}`;
  
  return (
    <div className={cn(
      "mini-map overflow-hidden rounded-md shadow-xs",
      size === 'sm' ? 'w-[150px] h-[120px] sm:w-[150px] sm:h-[120px] max-sm:w-[120px] max-sm:h-[100px]' : 'w-[200px] h-[160px]',
      className
    )}>
      <img 
        src={staticMapUrl}
        alt={`Location of ${displayName}`}
        className="w-full h-full object-cover"
        loading="lazy"
        onError={() => setImageError(true)}
      />
    </div>
  );
};

export default MiniMap;